"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHourlyInterest = useHourlyInterest;
var _react = require("react");
var _reactRedux = require("react-redux");
var _selectors = require("../../../redux/margin/selectors");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var _marginActions = require("../../../redux/margin/actions/marginActions");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
function useHourlyInterest(formName) {
  var _marginProducts$find;
  var dispatch = (0, _reactRedux.useDispatch)();
  var instrument = (0, _reactRedux.useSelector)(_instrumentPositionSelectors.selectedInstrumentSelector);
  var formValues = (0, _reactRedux.useSelector)(function (state) {
    var _state$form$formName;
    return (_state$form$formName = state.form[formName]) === null || _state$form$formName === void 0 ? void 0 : _state$form$formName.values;
  });
  var buy = formValues.side === _orderEntryFormConstants.buyValue;
  var payingProductId = buy ? instrument.Product2 : instrument.Product1;
  var marginProducts = (0, _reactRedux.useSelector)(_selectors.marginProductsSelector).data;
  var hasData = marginProducts.length > 0;
  var hourlyInterest = (((_marginProducts$find = marginProducts.find(function (product) {
    return product.ProductId === payingProductId;
  })) === null || _marginProducts$find === void 0 ? void 0 : _marginProducts$find.HourlyInterestRate) || 0) * 100;
  (0, _react.useEffect)(function () {
    if (!hasData) {
      dispatch((0, _marginActions.getMarginProductsConfig)());
    }
  }, [hasData, dispatch]);
  return hourlyInterest;
}